import React, { useRef } from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, children, title }) => {
    const modalRef = useRef(null);

    if (!isOpen) return null;

    const handleOverlayClick = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onClose();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-content" ref={modalRef}>
                <div className="modal-header">
                    <h2 className="modal-title">{title}</h2>
                    <button className="close-button" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="modal-divider"></div>
                <div className="modal-body">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;
